import type { ReactNode } from 'react';
import { InfoIcon } from '@phosphor-icons/react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type InfoHintProps = {
  /** Tooltip body shown on hover. */
  children: ReactNode;
  /** Icon size in px. Defaults to the compact 13px used across the app. */
  size?: number;
  /** Extra classes for the trigger wrapper. */
  className?: string;
  /** Extra classes for the tooltip content (e.g. `max-w-xs`). */
  contentClassName?: string;
};

/**
 * Small, faint-gray info icon paired with a hover tooltip — the standard
 * style for inline field and column hints. `Tooltip` already provides its own
 * `TooltipProvider`, so no surrounding provider is needed.
 */
export function InfoHint({
  children,
  size = 13,
  className,
  contentClassName,
}: InfoHintProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={['inline-flex items-center', className]
            .filter(Boolean)
            .join(' ')}
          style={{ cursor: 'help', color: '#6b7280' }}
        >
          <InfoIcon size={size} />
        </span>
      </TooltipTrigger>
      <TooltipContent className={contentClassName}>{children}</TooltipContent>
    </Tooltip>
  );
}
